import { ROLES } from '@/constants/roles';
import formatRoutes from '@/helpers/user-redesign/formatRoutes';

const routes = [
  {
    path: '/redesign/my-profile',
    name: 'my-profile',
    component: () => import('@/modules/UserProfile/views/my-profile.vue'),
    meta: {
      title: 'Мой профиль',
    },
  },
  {
    path: '/redesign/my-profile-duplicates',
    name: 'my-profile-duplicates',
    component: () => import('@/modules/UserProfile/views/my-profile-duplicates.vue'),
    meta: {
      title: 'Дубликаты моего профиля',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    path: '/redesign/my-portfolio',
    name: 'my-portfolio',
    component: () => import('@/modules/UserProfile/views/my-portfolio.vue'),
    meta: {
      title: 'Портфолио',
    },
  },
  {
    path: '/redesign/my-notifications',
    name: 'my-notifications',
    component: () => import('@/modules/UserProfile/views/my-notifications.vue'),
    meta: {
      title: 'Уведомления',
    },
  },
  {
    path: '/redesign/my-history',
    name: 'my-history',
    component: () => import('@/modules/UserProfile/views/my-history.vue'),
    meta: {
      title: 'Результаты',
      navigation: {
        back: false,
      },
    },
  },
  {
    path: '/redesign/instructions',
    name: 'my-instructions',
    component: () => import('@/modules/UserProfile/views/instructions.vue'),
    meta: {
      title: 'Инструкции',
    },
  },
];

export default formatRoutes(routes);
